import {
  Alert,
  Flex,
  FlexColumn,
  StatusChip,
} from '@elementary/common-ui/components';
import useAccountPermission from '@elementary/common-ui/hooks/useAccountPermission';
import { Typography } from '@mui/material';
import { RUNTIME_HEALTH_CHIP_STATUS } from '../constants';
import { Runtime } from '../types';
import { getRuntimeActivityLabel, getRuntimeStatusAlert } from '../utils';
import RuntimeActionsMenu from './RuntimeActionsMenu';

type Props = {
  runtime: Runtime;
};

const RuntimeStatusSummary = ({ runtime }: Props) => {
  const hasAccountPermission = useAccountPermission();
  const statusAlert = getRuntimeStatusAlert(runtime);

  return (
    <FlexColumn sx={{ gap: 2 }}>
      <FlexColumn sx={{ gap: 1 }}>
        <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Flex sx={{ gap: 1.5, alignItems: 'center', minWidth: 0 }}>
            <Typography variant="h3" noWrap>
              {runtime.name}
            </Typography>
            <StatusChip status={RUNTIME_HEALTH_CHIP_STATUS[runtime.health]} />
          </Flex>
          {hasAccountPermission('EDIT_RUNTIMES') && (
            <RuntimeActionsMenu runtime={runtime} />
          )}
        </Flex>
        <Typography variant="body1">
          {getRuntimeActivityLabel(runtime)}
        </Typography>
      </FlexColumn>

      {statusAlert && (
        <Alert severity={statusAlert.severity} title={statusAlert.title}>
          {statusAlert.message}
        </Alert>
      )}
    </FlexColumn>
  );
};

export default RuntimeStatusSummary;
